module.exports = __webpack_public_path__ + "img/pro-lab3.5cc41dae.png";